import { Button } from '@amzn/storm-ui';
import styled from 'styled-components';

export const StyledButton = styled(Button)<{ backgroundColor?: string }>`
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.color.blue[700]};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export const TooltipWrapper = styled.span`
  display: inline-block;
  cursor: not-allowed;
`;

export const TooltipInner = styled.span`
  pointer-events: none;
`;
